import React, { useEffect, useState } from "react";
import EmailVerify from "./Components/Dashbord/EmailVerify";
import { oneKlicks } from "../../SDK/oneclick";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { OneKlicksFileSDK } from "../../SDK/OneKlicksFileSDK";
import { getuserdata } from "../../services/apiService";

const ManageArticle = () => {
    const [userdata, setUserdata] = useState({});
    const [tabsest, setTabseset] = useState("Personal Details");
    const [categories, setCategories] = useState([]);
    const [tags, setTags] = useState([]);
    const [articles, setArticles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);
    const [featuredImage, setFeaturedImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [formData, setFormData] = useState({
        title: '',
        content: '',
        categories: [],
        tags: [],
        featured_image: null
    });
    const [editingArticle, setEditingArticle] = useState(null);

    useEffect(() => {
        const userData = localStorage.getItem("userData");
        if (userData) {
            setUserdata(userData);
        }
        getCategories();
        getTags();
        getArticles();
    }, []);

    const getArticles = async () => {
        const doctor_id = await getuserdata('id');
        setUserdata(doctor_id);
        setIsLoading(true);
        try {
            const tableSchema = "";
            const tableName = "articles";
            const conditions = { doctor_id: doctor_id };
            const orderBy = "id DESC";
            const search = [];
            const pagination = [];
            const margedata = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            
            if (response.success === true) {
                // Process each article to get specialities data
                const articlesWithSpecialities = await Promise.all(
                    response.data.map(async (article) => {
                        try {
                            // Parse categories if it's a string
                            const categoryIds = typeof article.categories === 'string' 
                                ? JSON.parse(article.categories) 
                                : article.categories;

                            // Get specialities data for each category
                            const specialitiesPromises = categoryIds.map(async (categoryId) => {
                                const specialitiesResponse = await oneKlicks.read(
                                    "", 
                                    "specialities", 
                                    { id: categoryId }, 
                                    "id DESC", 
                                    [], 
                                    [], 
                                    []
                                );
                                return specialitiesResponse.success ? specialitiesResponse.data[0] : null;
                            });

                            const specialitiesData = await Promise.all(specialitiesPromises);
                            const specialitiesNames = specialitiesData
                                .filter(s => s !== null)
                                .map(s => s.name);

                            return {
                                ...article,
                                specialities_names: specialitiesNames
                            };
                        } catch (error) {
                            console.error("Error processing article:", error);
                            return {
                                ...article,
                                specialities_names: []
                            };
                        }
                    })
                );

                setArticles(articlesWithSpecialities);
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getCategories = async () => {
        setIsLoading(true);
        try {
            const tableSchema = "";
            const tableName = "specialities";
            const conditions = {};
            const orderBy = "id DESC";
            const search = [];
            const pagination = [];
            const margedata = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("response", response);
            if (response.success === true) {
                setCategories(response.data);
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            setIsLoading(false);
        }
    };

    const getTags = async () => {
        setIsLoading(true);
        try {
            const tableSchema = "";
            const tableName = "tags";
            const conditions = {
                doctor_id: await getuserdata('id')
            };
            const orderBy = "id DESC";
            const search = [];  
            const pagination = [];
            const margedata = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("response", response);
            if (response.success === true) {
                setTags(response.data);
            }
        } catch (error) {
            console.log("error", error);
        } finally {
            setIsLoading(false);
        }
    };

    const categoryOptions = categories.map(category => ({
        value: category.id,
        label: category.name
    }));

    const tagOptions = tags.map(tag => ({
        value: tag.id,
        label: tag.name
    }));

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFeaturedImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleCategoryChange = (selectedOptions) => {
        setSelectedCategories(selectedOptions);
        setFormData(prev => ({
            ...prev,
            categories: selectedOptions.map(cat => cat.value)
        }));
    };

    const handleTagsChange = (newValue, actionMeta) => {
        if (actionMeta.action === 'create-option') {
            // Split the input by spaces and create multiple tags
            const words = actionMeta.option.value.split(/\s+/).filter(word => word.length > 0);
            const newTags = words.map(word => ({
                value: word,
                label: word
            }));
            
            // Combine existing tags with new tags
            const existingTags = selectedTags.filter(tag => 
                !newTags.some(newTag => newTag.value === tag.value)
            );
            const updatedTags = [...existingTags, ...newTags];
            setSelectedTags(updatedTags);
            setFormData(prev => ({
                ...prev,
                tags: updatedTags.map(tag => tag.value)
            }));
        } else {
            setSelectedTags(newValue);
            setFormData(prev => ({
                ...prev,
                tags: newValue.map(tag => tag.value)
            }));
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        try {
            let imageData = {};
            
            // Handle image upload only if there's a new image
            if (featuredImage) {
                const uploadFile = await OneKlicksFileSDK.uploadFile("articles", "public", featuredImage);
                imageData = {
                    featured_image: uploadFile.file.root + "/" + uploadFile.file.fileName,
                    featured_image_id: uploadFile.file.id
                };
            }

            // Process tags - handle both new and existing tags
            const processedTags = selectedTags.map(tag => {
                if (typeof tag.value === 'string' && !tag.value.match(/^\d+$/)) {
                    return {
                        id: tag.value,
                        name: tag.label
                    };
                }
                return {
                    id: tag.value,
                    name: tag.label
                };
            });

            const articleData = {
                title: formData.title,
                slug: formData.title.toLowerCase().replace(/ /g, '-'),
                doctor_id: await getuserdata('id'),
                content: formData.content,
                categories: JSON.stringify(selectedCategories.map(cat => cat.value)),
                tags: JSON.stringify(processedTags.map(tag => tag.id)),
                status: "pending",
                ...imageData // Spread the image data only if it exists
            };

            if (editingArticle) {
                // Update existing article
                const response = await oneKlicks.update("", "articles", articleData, { id: editingArticle.id });
                if (response.success) {
                    alert("Article updated successfully!");
                    resetForm();
                    getArticles();
                }
            } else {
                // Create new article
                const response = await oneKlicks.create("", "articles", articleData, {});
                if (response.success) {
                    alert("Article created successfully!");
                    resetForm();
                    getArticles();
                }
            }
        } catch (error) {
            console.log("error", error);
            alert("Error saving article");
        } finally {
            setIsLoading(false);
        }
    };

    const handleEdit = (article) => {
        setEditingArticle(article);
        
        // Parse categories and tags from JSON strings
        const parsedCategories = typeof article.categories === 'string' 
            ? JSON.parse(article.categories) 
            : article.categories || [];
            
        const parsedTags = typeof article.tags === 'string'
            ? JSON.parse(article.tags)
            : article.tags || [];

        setFormData({
            title: article.title,
            content: article.content,
            categories: parsedCategories,
            tags: parsedTags,
            featured_image: article.featured_image
        });

        // Get category options for the selected categories
        const selectedCategoryOptions = parsedCategories.map(categoryId => {
            const category = categories.find(cat => cat.id === categoryId);
            return category ? {
                value: category.id,
                label: category.name
            } : null;
        }).filter(Boolean);

        setSelectedCategories(selectedCategoryOptions);

        // Get tag options for the selected tags
        const selectedTagOptions = parsedTags.map(tagId => {
            const existingTag = tags.find(t => t.id === tagId);
            if (existingTag) {
                return {
                    value: existingTag.id,
                    label: existingTag.name
                };
            }
            return {
                value: tagId,
                label: tagId
            };
        }).filter(Boolean);

        setSelectedTags(selectedTagOptions);

        // Set the existing image
        if (article.featured_image) {
            setImagePreview(process.env.REACT_APP_API_BASE_URL + article.featured_image);
            setFeaturedImage(null); // Reset the new image input
        }
    };

    const handleDelete = async (articleId, article) => {
        if (window.confirm("Are you sure you want to delete this article?")) {
            setIsLoading(true);
            try {
                const tableSchema = "";
                const tableName = "articles";
                const conditions = { id: articleId };
                const response = await oneKlicks.delete(tableSchema, tableName, conditions);
                if (response.success) {
                    alert("Article deleted successfully!");
                    getArticles();
                    const fileResponse = await OneKlicksFileSDK.deleteFile("", "files", { id: article.featured_image_id });
                }
            } catch (error) {
                console.log("error", error);
                alert("Error deleting article");
            } finally {
                setIsLoading(false);
            }
        }
    };

    const resetForm = () => {
        setFormData({
            title: '',
            content: '',
            categories: [],
            tags: [],
            featured_image: null
        });
        setSelectedCategories([]);
        setSelectedTags([]);
        setFeaturedImage(null);
        setImagePreview(null);
        setEditingArticle(null);
    };

    return (
        <div className="subbody" style={{ width: '100%', padding: '2% 4%' }}>
            {userdata.activation_key == null && <EmailVerify />}
            
            <section className="dc-haslayout dc-dbsectionspace">
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <div className="dc-dashboardbox dc-offered-holder">
                            <div className="dc-dashboardboxtitle">
                                <h2>Article Listing</h2>
                            </div>
                            <div className="dc-dashboardboxcontent">
                                <div className="dc-contentdoctab dc-articles-holder dc-listedarticle">
                                    {isLoading ? (
                                        <div className="text-center">Loading...</div>
                                    ) : articles.length > 0 ? (
                                        <div className="dc-articles">
                                            {articles.map((article) => (
                                                <div key={article.id} className="dc-article">
                                                    <div className="dc-articlecontent" style={{ gap: '20px', padding: '20px', borderBottom: '1px solid #eee', marginBottom: '20px' }}>
                                                        {/* Left side - Image */}
                                                        <div className="dc-articleimage" style={{ flex: '0 0 200px' }}>
                                                            {article.featured_image ? (
                                                                <img 
                                                                    src={process.env.REACT_APP_API_BASE_URL + article.featured_image} 
                                                                    alt={article.title}
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '150px',
                                                                        objectFit: 'cover',
                                                                        borderRadius: '8px'
                                                                    }}
                                                                />
                                                            ) : (
                                                                <div style={{
                                                                    width: '100%',
                                                                    height: '150px',
                                                                    backgroundColor: '#f5f5f5',
                                                                    borderRadius: '8px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    color: '#999'
                                                                }}>
                                                                    No Image
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Right side - Content */}
                                                        <div className="dc-articleinfo" style={{ flex: '1' }}>
                                                            <h3 style={{ 
                                                                margin: '0 0 10px 0',
                                                                fontSize: '20px',
                                                                color: '#333'
                                                            }}>
                                                                {article.title}
                                                            </h3>
                                                            
                                                            {/* Content Preview */}
                                                            <div style={{ 
                                                                marginBottom: '15px',
                                                                color: '#666',
                                                                fontSize: '14px',
                                                                lineHeight: '1.5',
                                                                maxHeight: '60px',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                display: '-webkit-box',
                                                                WebkitLineClamp: '3',
                                                                WebkitBoxOrient: 'vertical'
                                                            }}>
                                                                {article.content.replace(/<[^>]*>/g, '')}
                                                            </div>

                                                            {/* Meta Information */}
                                                            <div className="dc-articlemeta" style={{ 
                                                                display: 'flex',
                                                                gap: '20px',
                                                                marginBottom: '15px',
                                                                fontSize: '13px',
                                                                color: '#666'
                                                            }}>
                                                                <div>
                                                                    <strong>Categories:</strong>{' '}
                                                                    {article.specialities_names && article.specialities_names.length > 0
                                                                        ? article.specialities_names.join(', ')
                                                                        : 'No categories'}
                                                                </div>
                                                                <div>
                                                                    <strong>Tags:</strong>{' '}
                                                                    {article.tags 
                                                                        ? (typeof article.tags === 'string' 
                                                                            ? JSON.parse(article.tags).join(', ')
                                                                            : article.tags.join(', '))
                                                                        : 'No tags'}
                                                                </div>
                                                                <div>
                                                                    <strong>Status:</strong>{' '}
                                                                    <span style={{
                                                                        color: article.status === 'published' ? '#28a745' : 
                                                                               article.status === 'pending' ? '#ffc107' : '#dc3545',
                                                                        textTransform: 'capitalize'
                                                                    }}>
                                                                        {article.status}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            {/* Actions */}
                                                            <div className="dc-articleactions" style={{ display: 'flex', gap: '10px' }}>
                                                                <button 
                                                                    className="dc-btn dc-btn-sm" 
                                                                    onClick={() => handleEdit(article)}
                                                                    disabled={editingArticle && editingArticle.id !== article.id}
                                                                    style={{
                                                                        padding: '8px 15px',
                                                                        backgroundColor: editingArticle && editingArticle.id !== article.id ? '#ccc' : '#007bff',
                                                                        color: 'white',
                                                                        border: 'none',
                                                                        borderRadius: '4px',
                                                                        cursor: editingArticle && editingArticle.id !== article.id ? 'not-allowed' : 'pointer',
                                                                        opacity: editingArticle && editingArticle.id !== article.id ? 0.7 : 1
                                                                    }}
                                                                >
                                                                    {editingArticle && editingArticle.id === article.id ? 'Editing...' : 'Edit'}
                                                                </button>
                                                                <button 
                                                                    className="dc-btn dc-btn-sm dc-btn-danger" 
                                                                    onClick={() => handleDelete(article.id, article)}
                                                                    disabled={editingArticle && editingArticle.id !== article.id}
                                                                    style={{
                                                                        padding: '8px 15px',
                                                                        backgroundColor: editingArticle && editingArticle.id !== article.id ? '#ccc' : '#dc3545',
                                                                        color: 'white',
                                                                        border: 'none',
                                                                        borderRadius: '4px',
                                                                        cursor: editingArticle && editingArticle.id !== article.id ? 'not-allowed' : 'pointer',
                                                                        opacity: editingArticle && editingArticle.id !== article.id ? 0.7 : 1
                                                                    }}
                                                                >
                                                                    Delete
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="dc-emptydata-holder">
                                            <div className="dc-emptydata">
                                                <div className="dc-emptydetails dc-empty-articls dc-emptyholder-sm">
                                                    <span></span>
                                                    <em>No Article posted yet.</em>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 dc-dashboardbox-mt mt-lg-0 mt-xl-0">
                        <div className="dc-dashboardbox">
                            <div className="dc-dashboardboxtitle">
                                <h2>{editingArticle ? 'Edit Article' : 'Post a new article'}</h2>
                            </div>
                            <form className="dc-post-artical" method="post" onSubmit={handleSubmit}>
                                <div className="dc-dashboardboxcontent dc-addservices dc-articlesservices">
                                    <div className="dc-tabscontenttitle">
                                        <h3>Add Article Detail</h3>
                                    </div>
                                    <div className="dc-formtheme dc-userform">
                                        <fieldset>
                                            <div className="form-group toolip-wrapo">
                                                <input 
                                                    type="text" 
                                                    name="post_title" 
                                                    className="form-control" 
                                                    placeholder="Article Title" 
                                                    value={formData.title}
                                                    onChange={(e) => setFormData({...formData, title: e.target.value})}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group dc-tinymceeditor">
                                                <textarea 
                                                    className="customwp_editor wp-editor-area" 
                                                    style={{ height: '300px' }} 
                                                    autoComplete="off" 
                                                    cols="40" 
                                                    name="post_content" 
                                                    id="post_content"
                                                    value={formData.content}
                                                    onChange={(e) => setFormData({...formData, content: e.target.value})}
                                                    required
                                                >
                                                    Article contents...
                                                </textarea>
                                            </div>
                                        </fieldset>
                                    </div>

                                    <div className="dc-featuredphoto-holder dc-tabsinfo">
                                        <div className="dc-tabscontenttitle">
                                            <h3>Featured Photo</h3>
                                        </div>
                                        <div className="dc-profilephotocontent">
                                            <div className="dc-formtheme dc-formprojectinfo dc-formcategory">
                                                <fieldset>
                                                    <div className="form-group form-group-label">
                                                        <div className="dc-labelgroup">
                                                            <label htmlFor="featured-image" className="dc-image-file">
                                                                <span className="ajax-load dc-btn">Select File</span>
                                                            </label>
                                                            <span>Drop files here to upload</span>
                                                            <em className="dc-fileuploading">
                                                                Uploading<i className="fa fa-spinner fa-spin"></i>
                                                            </em>
                                                        </div>
                                                        <input 
                                                            type="file" 
                                                            id="featured-image" 
                                                            accept="image/jpeg,.jpg,.jpeg,image/gif,.gif,image/png,.png"
                                                            onChange={handleImageChange}
                                                            style={{ display: 'none' }}
                                                            required={!editingArticle && !imagePreview}
                                                        />
                                                    </div>
                                                    {imagePreview && (
                                                        <div className="form-group uploaded-placeholder">
                                                            <img 
                                                                src={imagePreview} 
                                                                alt="Preview" 
                                                                style={{ 
                                                                    maxWidth: '100%', 
                                                                    maxHeight: '200px',
                                                                    marginTop: '10px',
                                                                    borderRadius: '4px'
                                                                }} 
                                                            />
                                                        </div>
                                                    )}
                                                </fieldset>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="dc-category-holder dc-tabsinfo">
                                        <div className="dc-tabscontenttitle">
                                            <h3>Select Category</h3>
                                        </div>
                                        <div className="dc-articletag-holder">
                                            <div className="dc-formtheme dc-skillsform">
                                                <fieldset>
                                                    <div className="form-group">
                                                        <Select
                                                            isMulti
                                                            name="post_categories"
                                                            options={categoryOptions}
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                            value={selectedCategories}
                                                            onChange={handleCategoryChange}
                                                            placeholder="Select categories..."
                                                            required
                                                        />
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="dc-addtag-holder dc-tabsinfo">
                                        <div className="dc-tabscontenttitle">
                                            <h3>Add Tags</h3>
                                        </div>
                                        <div className="dc-articletag-holder">
                                            <div className="dc-formtheme dc-skillsform">
                                                <fieldset>
                                                    <div className="form-group">
                                                        <CreatableSelect
                                                            isMulti
                                                            name="post_tags"
                                                            options={tagOptions}
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                            value={selectedTags}
                                                            onChange={handleTagsChange}
                                                            placeholder="Type words and press Enter..."
                                                            formatCreateLabel={(inputValue) => `Add tags: "${inputValue}"`}
                                                            isValidNewOption={(inputValue) => inputValue.length > 0}
                                                            createOptionPosition="first"
                                                            blurInputOnSelect={false}
                                                        />
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="dc-btnarea">
                                        <button type="submit" className="dc-btn dc-add-posts">
                                            {editingArticle ? 'Update Article' : 'Post Now'}
                                        </button>
                                        {editingArticle && (
                                            <button 
                                                type="button" 
                                                className="dc-btn dc-btn-secondary" 
                                                onClick={resetForm}
                                            >
                                                Cancel
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ManageArticle;
